import DataSeriesChart from './DataSeriesChart'

export default {
  DataSeriesChart
}
